import React, { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { AddGraph } from '../appActions';
import cross_logo from '../Assets/Icons/cross.png';
import configVariables, { grpahImages } from '../util/constants';
import InfoButton from './InfoButton';
import './AddGraphForm.css'; // We will create this file for styling

function AddGraphForm({ user_det, setCloseModal, fetchGraphs, edit_obj }) {
  const { register, handleSubmit, getValues, setValue, watch } = useForm({
    defaultValues: {
      fetch_data_period: 7,
      ...edit_obj,
      project_id: edit_obj?.device_id.project_id,
      device_id: edit_obj?.device_id._id,
      sensor_id: edit_obj?.sensor_id._id,
    },
  });
  const dispatch = useDispatch();

  const [step, setStep] = useState(1);
  const [projectOptions, setProjectOptions] = useState([]);
  const [deviceOptions, setDeviceOptions] = useState([]);
  const [sensorOptions, setSensorOptions] = useState([]);
  const [selectedSensor, setSelectedSensor] = useState({});
  const [graphImagePath, setGraphImagePath] = useState('');
  const [businessSearch, setBusinessSearch] = useState("");
  const [projectSearch, setProjectSearch] = useState("");
  const [deviceSearch, setDeviceSearch] = useState("");
  const [businessSearchOpen, setBusinessSearchOpen] = useState(false);
  const [projectSearchOpen, setProjectSearchOpen] = useState(false);
  const [deviceSearchOpen, setDeviceSearchOpen] = useState(false);

  const getObjectById = (arr, id) => {
    for (let i = 0; i < arr.length; i++) {
      if (arr[i]._id === id) {
        return arr[i];
      }
    }
    return null;
  };
  
  const watchedValues = watch();

  const handleNext = () => {
    if (step === 1 && watchedValues.business_id) {
        const business = getObjectById(user_det.business_id, watchedValues.business_id);
        if (business) setProjectOptions(business.project_id);
    }
    if (step === 2 && watchedValues.project_id) {
        const project = getObjectById(projectOptions, watchedValues.project_id);
        if (project) setDeviceOptions(project.device_id);
    }
    if (step === 3 && watchedValues.device_id) {
        const device = getObjectById(deviceOptions, watchedValues.device_id);
        if (device) setSensorOptions(device.sensor_id);
    }
    if (step === 4 && watchedValues.sensor_id) {
        const sensor = getObjectById(sensorOptions, watchedValues.sensor_id);
        if (sensor) setSelectedSensor(sensor);
    }
    if (step === 5 && watchedValues.type) {
        const imgPath = grpahImages[watchedValues.type];
        setGraphImagePath(imgPath);
    }
    setStep(step + 1);
  };

  const handlePrevious = () => {
    setStep(step - 1);
  };

  const handleSelect = (field, value) => {
    const currentValue = getValues(field);
    if (currentValue === value) {
      setValue(field, null); //Deselect if clicked again
    } else {
      setValue(field, value);
    }

    // Reset subsequent fields on change
    const fieldsToReset = {
        'business_id': ['project_id', 'device_id', 'sensor_id', 'type'],
        'project_id': ['device_id', 'sensor_id', 'type'],
        'device_id': ['sensor_id', 'type'],
        'sensor_id': ['type']
    };

    if (fieldsToReset[field]) {
        fieldsToReset[field].forEach(f => setValue(f, null));
    }
  };
  const onSubmit = (data) => {
    if (user_det.userRole === configVariables.role_owner) {
      data.owner_id = [user_det._id];
    } else if (user_det.userRole === configVariables.role_manager) {
      data.manager_id = [user_det._id];
    } else {
      data.super_id = [user_det._id];
    }

    if (data.type) {
      dispatch(AddGraph(data)).then((status) => {
        if (status) {
          setCloseModal(false);
          fetchGraphs();
          window.location.reload();
        }
      });
    } else {
      alert("Please select a graph type");
    }
  };

  const renderStepContent = () => {
    switch (step) {
      case 1:
        return (
          <div>
            <h3 className="step-title">Select Business <InfoButton content={"Choose the business you want to add a graph for."} /></h3>
            

            <div className="search-row">
              {businessSearchOpen ? (
                <input
                  type="text"
                  className="search-input expanded"
                  placeholder="Search business..."
                  value={businessSearch}
                  autoFocus
                  onChange={e => setBusinessSearch(e.target.value)}
                  onBlur={e => {
                    if (!e.target.value) setBusinessSearchOpen(false);
                  }}
                  style={{marginBottom: 16, width: '100%', maxWidth: 400}}
                  onKeyDown={e => { if (e.key === 'Enter') e.preventDefault(); }}
                />
              ) : (
                <button
                  type="button"
                  className="search-icon-btn"
                  onClick={() => setBusinessSearchOpen(true)}
                  aria-label="Search"
                  style={{marginBottom: 16}}
                >
                  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="10" cy="10" r="7" stroke="#7469B6" strokeWidth="2" />
                    <line x1="16" y1="16" x2="21" y2="21" stroke="#7469B6" strokeWidth="2" strokeLinecap="round" />
                  </svg>
                </button>
              )}
            </div>
            <div className={`options-grid${user_det?.business_id?.filter(business => business.name.toLowerCase().includes(businessSearch.toLowerCase())).length === 1 ? ' single-option' : ''}`}>
              {user_det?.business_id
                ?.filter(business => business.name.toLowerCase().includes(businessSearch.toLowerCase()))
                .sort((a, b) => {
                  // If search is empty, keep original order
                  if (!businessSearch) return 0;
                  // If a starts with search, put it before b
                  const aStarts = a.name.toLowerCase().startsWith(businessSearch.toLowerCase());
                  const bStarts = b.name.toLowerCase().startsWith(businessSearch.toLowerCase());
                  if (aStarts && !bStarts) return -1;
                  if (!aStarts && bStarts) return 1;
                  return 0;
                })
                .map((business) => (
                  <button
                    key={business._id}
                    type="button"
                    className={`option-button${watchedValues.business_id === business._id ? ' selected' : ''}`}
                    onClick={() => handleSelect('business_id', business._id)}
                  >
                    {business.name}
                  </button>
                ))}
            </div>
          </div>
        );
      case 2:
        return (
          <div>
            <h3 className="step-title">Select Project <InfoButton content={"Pick a project under the selected business."} /></h3>
            <div className="search-row">
              {projectSearchOpen ? (
                <input
                  type="text"
                  className="search-input expanded"
                  placeholder="Search project..."
                  value={projectSearch}
                  autoFocus
                  onChange={e => setProjectSearch(e.target.value)}
                  onBlur={e => {
                    if (!e.target.value) setProjectSearchOpen(false);
                  }}
                  style={{marginBottom: 16, width: '100%', maxWidth: 400}}
                  onKeyDown={e => { if (e.key === 'Enter') e.preventDefault(); }}
                />
              ) : (
                <button
                  type="button"
                  className="search-icon-btn"
                  onClick={() => setProjectSearchOpen(true)}
                  aria-label="Search"
                  style={{marginBottom: 16}}
                >
                  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="10" cy="10" r="7" stroke="#7469B6" strokeWidth="2" />
                    <line x1="16" y1="16" x2="21" y2="21" stroke="#7469B6" strokeWidth="2" strokeLinecap="round" />
                  </svg>
                </button>
              )}
            </div>
            <div className={`options-grid${projectOptions?.filter(project => project.name.toLowerCase().includes(projectSearch.toLowerCase())).length === 1 ? ' single-option' : ''}`}>
              {projectOptions
                ?.filter(project => project.name.toLowerCase().includes(projectSearch.toLowerCase()))
                .sort((a, b) => {
                  if (!projectSearch) return 0;
                  const aStarts = a.name.toLowerCase().startsWith(projectSearch.toLowerCase());
                  const bStarts = b.name.toLowerCase().startsWith(projectSearch.toLowerCase());
                  if (aStarts && !bStarts) return -1;
                  if (!aStarts && bStarts) return 1;
                  return 0;
                })
                .map((project) => (
                  <button
                    key={project._id}
                    type="button"
                    className={`option-button${watchedValues.project_id === project._id ? ' selected' : ''}`}
                    onClick={() => handleSelect('project_id', project._id)}
                  >
                    {project.name}
                  </button>
                ))}
            </div>
          </div>
        );
      case 3:
        return (
            <div>
              <h3 className="step-title">Select Device <InfoButton content={"Select the device you want to visualize data from."} /></h3>
              <div className="search-row">
                {deviceSearchOpen ? (
                  <input
                    type="text"
                    className="search-input expanded"
                    placeholder="Search device..."
                    value={deviceSearch}
                    autoFocus
                    onChange={e => setDeviceSearch(e.target.value)}
                    onBlur={e => {
                      if (!e.target.value) setDeviceSearchOpen(false);
                    }}
                    style={{marginBottom: 16, width: '100%', maxWidth: 400}}
                    onKeyDown={e => { if (e.key === 'Enter') e.preventDefault(); }}
                  />
                ) : (
                  <button
                    type="button"
                    className="search-icon-btn"
                    onClick={() => setDeviceSearchOpen(true)}
                    aria-label="Search"
                    style={{marginBottom: 16}}
                  >
                    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="10" cy="10" r="7" stroke="#7469B6" strokeWidth="2" />
                      <line x1="16" y1="16" x2="21" y2="21" stroke="#7469B6" strokeWidth="2" strokeLinecap="round" />
                    </svg>
                  </button>
                )}
              </div>
              <div className={`options-grid${deviceOptions?.filter(device => device.name.toLowerCase().includes(deviceSearch.toLowerCase())).length === 1 ? ' single-option' : ''}`}>
                {deviceOptions
                  ?.filter(device => device.name.toLowerCase().includes(deviceSearch.toLowerCase()))
                  .sort((a, b) => {
                    if (!deviceSearch) return 0;
                    const aStarts = a.name.toLowerCase().startsWith(deviceSearch.toLowerCase());
                    const bStarts = b.name.toLowerCase().startsWith(deviceSearch.toLowerCase());
                    if (aStarts && !bStarts) return -1;
                    if (!aStarts && bStarts) return 1;
                    return 0;
                  })
                  .map((device) => (
                    <button
                      key={device._id}
                      type="button"
                      className={`option-button${watchedValues.device_id === device._id ? ' selected' : ''}`}
                      onClick={() => handleSelect('device_id', device._id)}
                    >
                      {device.name}
                    </button>
                  ))}
              </div>
            </div>
          );
      case 4:
        return (
            <div className="step-4">
              <h3 className="step-title">Select Sensor <InfoButton content={"Choose the sensor whose data you want to graph. "} /></h3>
              <br></br><br />
              <div className='sensor-options-row single-option'>
                {sensorOptions?.map((sensor) => (
                  <button
                    key={sensor._id}
                    type="button"
                    className={`option-button${watchedValues.sensor_id === sensor._id ? ' selected' : ''}`}
                    onClick={() => handleSelect('sensor_id', sensor._id)}
                  >
                    {sensor.name}
                  </button>
                ))}
              </div>
            </div>
          );
      case 5:
        return (
            <div>
              <h3 className="step-title">Select Graph Type <InfoButton content={"Pick a graph type that best represents your sensor data."} /></h3>
              <br />
              <div className="graph-type-grid">
                {selectedSensor?.type?.graph_types?.map((graph) => {
                  const imgPath = grpahImages[graph];
                  const isSelected = watchedValues.type === graph;
                  return (
                    <div
                      key={graph}
                      className={`graph-type-card${isSelected ? ' selected' : ''}`}
                      onClick={() => {
                        handleSelect('type', graph);
                        setGraphImagePath(imgPath);
                      }}
                      tabIndex={0}
                      role="button"
                      aria-pressed={isSelected}
                    >
                      {imgPath ? (
                        <img
                          src={imgPath}
                          alt={graph + ' graph'}
                          className="graph-type-card-img"
                        />
                      ) : (
                        <div className="graph-type-card-noimg">No image</div>
                      )}
                      <div className="graph-type-card-name">{graph}</div>
                    </div>
                  );
                })}
              </div>
            </div>
          );
      case 6:
        return (
            <div className="form-inputs">
                <h3 className="step-title">Graph Details <InfoButton content={"Set a name for your graph "} /></h3>
                <label className='form-label' htmlFor="">
                    Graph Name
                    <input type="text" className="full-width-input" {...register('name', { required: true })} />
                </label>
                <label className='form-label' htmlFor="">
                <p >fetch Data<InfoButton content={' fetch data. Min 3, Max 20.'} /></p>
                    
                    <div className="range-row">
                      <input
                        type="range"
                        min={3}
                        max={20}
                        step={1}
                        value={watch('fetch_data_period') || 7}
                        onChange={e => setValue('fetch_data_period', Number(e.target.value))}
                        className="fetch-range"
                        {...register('fetch_data_period', { required: true })}
                      />
                      <span className="range-value">{watch('fetch_data_period') || 7}</span>
                    </div>
                </label>
            </div>
        )
      case 7:
        const businessName = getObjectById(user_det?.business_id, watchedValues.business_id)?.name;
        const projectName = getObjectById(projectOptions, watchedValues.project_id)?.name;
        const deviceName = getObjectById(deviceOptions, watchedValues.device_id)?.name;
        const sensorName = getObjectById(sensorOptions, watchedValues.sensor_id)?.name;
        
        return (
          <div className="summary-view">
            <h3 className="step-title">Summary <InfoButton content={"Review your selections. Use Edit to go back and change any step before submitting."} /></h3>
            <div className="summary-table">
              <div key="business-row" className="summary-row">
                <div className="summary-label">Business:</div>
                <div className="summary-value">{businessName || 'Not selected'}</div>
                <button type="button" className="summary-edit" onClick={() => setStep(1)}>Edit</button>
              </div>
              <div key="project-row" className="summary-row">
                <div className="summary-label">Project:</div>
                <div className="summary-value">{projectName || 'Not selected'}</div>
                <button type="button" className="summary-edit" onClick={() => setStep(2)}>Edit</button>
              </div>
              <div key="device-row" className="summary-row">
                <div className="summary-label">Device:</div>
                <div className="summary-value">{deviceName || 'Not selected'}</div>
                <button type="button" className="summary-edit" onClick={() => setStep(3)}>Edit</button>
              </div>
              <div key="sensor-row" className="summary-row">
                <div className="summary-label">Sensor:</div>
                <div className="summary-value">{sensorName || 'Not selected'}</div>
                <button type="button" className="summary-edit" onClick={() => setStep(4)}>Edit</button>
              </div>
              <div key="graph-type-row" className="summary-row">
                <div className="summary-label">Graph Type:</div>
                <div className="summary-value">{watchedValues.type || 'Not selected'}</div>
                <button type="button" className="summary-edit" onClick={() => setStep(5)}>Edit</button>
              </div>
              <div key="graph-name-row" className="summary-row">
                <div className="summary-label">Graph Name:</div>
                <div className="summary-value">{watchedValues.name || 'Not set'}</div>
                <button type="button" className="summary-edit" onClick={() => setStep(6)}>Edit</button>
              </div>
              <div key="fetch-period-row" className="summary-row">
                <div className="summary-label">Fetch data:</div>
                <div className="summary-value">{watchedValues.fetch_data_period}</div>
                <button type="button" className="summary-edit" onClick={() => setStep(6)}>Edit</button>
              </div>
            </div>
          </div>
        )
      default:
        return null;
    }
  };

  const isNextDisabled = () => {
    switch (step) {
        case 1: return !watchedValues.business_id;
        case 2: return !watchedValues.project_id;
        case 3: return !watchedValues.device_id;
        case 4: return !watchedValues.sensor_id;
        case 5: return !watchedValues.type;
        case 6: return !watchedValues.name;
        default: return false;
    }
  }

  return (
    <div className="modal">
      <form onSubmit={handleSubmit(onSubmit)} className="multistep-form" autoComplete="off">
     

        <img
          onClick={() => setCloseModal(false)}
          className="form-cross-but"
          src={cross_logo}
          alt="close"
        />
        <div className="form-content">
            {renderStepContent()}
        </div>
        <div className="navigation-buttons">
          {step > 1 && (
            <a
              className="form-but-1 prev nav-link"
              onClick={e => { e.preventDefault(); handlePrevious(); }}
              href="#"
              tabIndex={0}
            >
             <span className="arrow">&#8592;</span> Previous 
            </a>
          )}
          {step < 7 && (
            <a
              className={`form-but-1 next nav-link${isNextDisabled() ? ' disabled' : ''}`}
              onClick={e => { e.preventDefault(); if (!isNextDisabled()) handleNext(); }}
              href="#"
              tabIndex={0}
              aria-disabled={isNextDisabled()}
            >
              Next <span className="arrow">&#8594;</span>
            </a>
          )}
          {step === 7 && <button type="submit" className="form-but-1 submit">Add Graph</button>}
        </div>
      </form>
    </div>
  );
}

export default AddGraphForm;
